export var NBSP = "\xA0";